<template>
  <section class="flex level-1" v-touch:swipe.right="swipeRightHandler">   

        <!-- //TITLE MOBILE -->
          <div class="mobile"  :class="{isMobile:isMobile}">
            <div class="link">
              <button class="bt btn-back" @click="goBack()">
                <font-awesome-icon :icon="['far', 'angle-left']"/>
              </button>
              <h2>Destinations <div class="sub">Costa rica</div></h2>
            </div>
            <div class="sep"></div>
          </div>
        <!-- //TITLE MOBILE -->

        <!-- CONTENT-->
        <div class="block__destination content__destination">

              <!-- PART MIDDLE -->
                <div class="header entete desktop">
                  <PuSkeleton :loading="isLoading" :count="1" width='240px'>
                    <p>Destinations <span class="sub">Costa rica</span></p>
                  </PuSkeleton>
                </div>

                <!-- SLIDER MOBILE -->
                <div class="block__slider cardSimple mobile">
                  <VueSlickCarousel v-bind="settings">
                    <div  class="wrapper">
                      <b-img :src="content.src" class="" fluid alt="placeholder"></b-img>
                    </div>

                    <div  class="wrapper">
                      <b-img :src="content.thumbnail1" class=""  alt="placeholder"></b-img>         
                    </div>

                    <div  class="wrapper">
                      <b-img :src="content.thumbnail2" class=""  alt="placeholder"></b-img>
                    </div>
                  </VueSlickCarousel>
                </div>
                <!-- SLIDER MOBILE -->
                



                <div class="desktop">
                  <div class="block__3imgs ">
                        <PuSkeleton :loading="isLoading" :count="1" height="300px">
                          <div>
                              <b-img :src="content.src" class="" fluid alt="placeholder"></b-img>
                          </div>
                          <div>
                            <b-img :src="content.thumbnail1" class=""  alt="placeholder"></b-img>
                            <b-img :src="content.thumbnail2" class=""  alt="placeholder"></b-img>
                          </div>
                        </PuSkeleton>
                  </div>
                </div>


                <div class="block__flex  mt-4">
                  <div>
                    <PuSkeleton :loading="isLoading" :count="10">
                      <div class="header entete">
                        <p>Description</p>
                      </div>

                      <div class="content_desc" v-html="content.content">
                      </div>
                    </PuSkeleton>
                  </div>  

                  <div>
                    <PuSkeleton :loading="isLoading" :count="1" height="100px">
                      <b-card class="block__planeDates" title="Période du voyage">
                          <b-list-group>
                            <b-list-group-item>
                              <i class="fas fa-plane-departure blue"></i> 
                              <div class="date">{{content.dateStart}}</div>
                            </b-list-group-item>

                            <b-list-group-item>
                              <i class="fas fa-plane-arrival yellow"></i> 
                              <div class="date">{{content.dateEnd}}</div>
                            </b-list-group-item>
                          </b-list-group>
                      </b-card>
                    </PuSkeleton>
                  </div>
                  
                </div>
              <!-- PART MIDDLE -->

        </div>
        <!-- CONTENT-->
      </section>

</template>


<script>
import { mapGetters } from 'vuex'
import ParentMixin from '../../ParentMixin'

export default {
  name:"challengeDestinations",
    components:{ 
    },
    mixins: [
      ParentMixin
    ],     
    computed: {
      ...mapGetters([
        'getDestination',
      ])
    },
    data () {
      return {
        content:"",
        isLoading:true,
      }
    },
    created (){
      this.content = this.getDestination;
      setTimeout(() => {
        this.isLoading = false;
        // this.majData();
      },2000);       
    },    
    methods : { 
      goBack() {
        this.$store.dispatch('goBack')
        this.$router.push({name: "challengesHome"});  
      }, 
      swipeRightHandler () {
          this.goBack();
      },                      
    }
};
</script>
